<template>
	<div>
		<!--编辑 -->
		<el-dialog title="批量上传" :visible.sync="dialog" @close="unShowClick()" width="35%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<div style="display: flex;align-items: center;justify-content: flex-end;margin-bottom: 20px;">
					<div @click="downModeal">模版下载</div>
				</div>
				<el-upload class="upload-demo" drag :limit='1' :file-list='fileList' accept='.xls,.xlsx'
					:http-request='httpRequest' action='' :auto-upload="false" ref="upload" multiple>
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">请上传已填写完毕的模板文件</div>
					<div class="el-upload__tip" slot="tip">仅支持上传单个文件，再次上传将替换原上传文件</div>
				</el-upload>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="updateUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import {
		UserImport
	} from '@/api/user'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				imgDomain,
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {},
				images: [],
				roleUuid: "",
				rules: {},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [],
				fileList: []
			}
		},
		mounted() {},
		methods: {
			downModeal() {
				window.open(imgDomain + 'academy/044ad04810c85c04a676c068290bc22a.xlsx')
			},
			async httpRequest(file) {
				const formData = new FormData();
				formData.append('file', file.file);
				const res = await UserImport(formData).catch(() => {});
				if (res.status === 200) {
					this.$message.success('导入成功')
					this.$emit('confirm')
				}
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			updateUser(formName) {
				this.$refs.upload.submit();
				// this.$refs[formName].validate((valid) => {
				// 	if (valid) {
				// 		if (this.isEdit) {
				// 			this.network().updateUser()
				// 		} else {
				// 			this.network().addUser()
				// 		}
				// 	} else {
				// 		return false;
				// 	}
				// 	return false
				// });
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addUser: async () => {
						const {
							status,
							data
						} = await addUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateUser: async () => {
						const {
							status
						} = await updateUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
				}
			},
		},

		watch: {
			dialogProp(old) {
				this.fileList = []
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
	.upload-demo {
		width: 100%;
	}

	/deep/ .el-upload-dragger {
		width: 100%;
	}

	/deep/ .el-upload {
		width: 100%;
	}
</style>